export default "__VITE_ASSET__Cqg5jYI2__"